<template>
    <div>
        <div class="navbar navbar-expand-md navbar-dark bg-indigo navbar-static fixed-top">
            <div class="d-md-none">
                <button @click="toggleSidebar" class="navbar-toggler sidebar-mobile-main-toggle" type="button">
                    <i class="icon-paragraph-justify3"></i>
                </button>
            </div>
            <div class="collapse navbar-collapse" id="navbar-mobile">
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <a href="#" class="navbar-nav-link sidebar-control sidebar-main-toggle d-none d-md-block">
                            <i class="icon-paragraph-justify3"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <!-- Page content -->
        <div class="page-content" style="height:100% !important;">
            <!-- Main sidebar -->
            <div class="sidebar sidebar-light sidebar-main sidebar-expand-md">
                <!-- Sidebar mobile toggler -->
                <div class="sidebar-mobile-toggler text-center">
                    <a @click="toggleSidebar" style="cursor: pointer" class="sidebar-mobile-main-toggle">
                        <i class="icon-arrow-left8"></i>
                    </a>
                </div>
                <!-- /sidebar mobile toggler -->
                <!-- Sidebar content -->
                <div class="sidebar-content">
                    <!-- Main navigation -->
                    <div class="card card-sidebar-mobile">
                        <ul class="nav nav-sidebar" data-nav-type="accordion">
                            <!--                             <li class="nav-item">
                                <router-link :to="{name:'dashboard'}" class="nav-link" :class="{'active':$route.name === 'dashboard'}">
                                    <i class="icon-home4"></i>
                                    <span>Dashboard</span>
                                </router-link>
                            </li> -->
                            <li class="nav-item">
                                <router-link :to="{ name: 'domains' }" class="nav-link"
                                    :class="{ 'active': $route.name === 'domains' }">
                                    <i class="icon-price-tag2"></i>
                                    <span>Domains</span>
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link :to="{ name: 'authenticated_domains' }" class="nav-link"
                                    :class="{ 'active': $route.name === 'authenticated_domains' }">
                                    <i class="icon-price-tag2"></i>
                                    <span>Sendgrid Domains</span>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="$storage.acl === 'admin'">
                                <router-link :to="{ name: 'contact_lists' }" class="nav-link"
                                    :class="{ 'active': $route.name === 'contact_lists' }">
                                    <i class="icon-person"></i>
                                    <span>Contact lists</span>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="$storage.acl === 'admin'">
                                <router-link :to="{ name: 'templates' }" class="nav-link"
                                    :class="{ 'active': $route.name === 'templates' }">
                                    <i class="icon-person"></i>
                                    <span>Message templates</span>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="$storage.acl === 'admin'">
                                <router-link :to="{ name: 'bulk_list_upload' }" class="nav-link"
                                    :class="{ 'active': $route.name === 'bulk_list_upload' }">
                                    <i class="icon-person"></i>
                                    <span>Bulk list upload</span>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="$storage.acl === 'admin'">
                                <router-link :to="{ name: 'campaign_list' }" class="nav-link"
                                    :class="{ 'active': $route.name === 'campaign_list' }">
                                    <i class="icon-feed"></i>
                                    <span>Campaigns</span>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="$storage.acl === 'admin'">
                                <router-link :to="{ name: 'stats' }" class="nav-link"
                                    :class="{ 'active': $route.name === 'stats' }">
                                    <i class="icon-drawer-out"></i>
                                    <span>Stats</span>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="$storage.acl === 'admin'">
                                <router-link :to="{ name: 'engagement_stats' }" class="nav-link"
                                    :class="{ 'active': $route.name === 'engagement_stats' }">
                                    <i class="icon-drawer-out"></i>
                                    <span>Engagement stats</span>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="$storage.acl === 'admin'">
                                <router-link :to="{ name: 'account_stats' }" class="nav-link"
                                    :class="{ 'active': $route.name === 'account_stats' }">
                                    <i class="icon-drawer-out"></i>
                                    <span>Account stats</span>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="$storage.acl === 'admin'">
                                <router-link :to="{ name: 'event_summary' }" class="nav-link"
                                    :class="{ 'active': $route.name === 'event_summary' }">
                                    <i class="icon-drawer-out"></i>
                                    <span>Event summary</span>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="$storage.acl === 'admin'">
                                <router-link :to="{ name: 'event_summary_receiving' }" class="nav-link"
                                    :class="{ 'active': $route.name === 'event_summary_receiving' }">
                                    <i class="icon-drawer-out"></i>
                                    <span>Event summary receiving</span>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="$storage.acl === 'admin'">
                                <router-link :to="{ name: 'suppression_list', params: { 'type': 'suppression' } }"
                                    class="nav-link"
                                    :class="{ 'active': $route.name === 'suppression_list' && $route.params.type === 'suppression' }">
                                    <i class="icon-blocked"></i>
                                    <span>Suppression list</span>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="$storage.acl === 'admin'">
                                <router-link :to="{ name: 'suppression_list', params: { 'type': 'deferral' } }"
                                    class="nav-link"
                                    :class="{ 'active': $route.name === 'suppression_list' && $route.params.type === 'deferral' }">
                                    <i class="icon-blocked"></i>
                                    <span>Blocked domain</span>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="$storage.acl === 'admin'">
                                <router-link :to="{ name: 'suppression_list', params: { 'type': 'unsubscribe' } }"
                                    class="nav-link"
                                    :class="{ 'active': $route.name === 'suppression_list' && $route.params.type === 'unsubscribe' }">
                                    <i class="icon-drawer-out"></i>
                                    <span>Bounce & Unsubscribe list</span>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="$storage.acl === 'admin'">
                                <router-link :to="{ name: 'suppression_list', params: { 'type': 'spam' } }"
                                    class="nav-link"
                                    :class="{ 'active': $route.name === 'suppression_list' && $route.params.type === 'spam' }">
                                    <i class="icon-spam"></i>
                                    <span>Spam list</span>
                                </router-link>
                            </li>
                            <li class="nav-item" style="cursor:pointer;" v-if="$storage.acl === 'admin'">
                                <span style="" @click="listSorter = true" class="nav-link"><i class="icon-sort"></i>
                                    <span>Sort list</span></span>
                            </li>
                            <li class="nav-item" v-if="$storage.acl === 'admin'">
                                <router-link :to="{ name: 'worker_list' }" class="nav-link"
                                    :class="{ 'active': $route.name === 'workers' }">
                                    <i class="icon-tree6"></i>
                                    <span>Workers</span>
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link :to="{ name: 'proxy_list' }" class="nav-link"
                                    :class="{ 'active': $route.name === 'proxy_list' }">
                                    <i class="icon-anchor"></i>
                                    <span>Proxy list</span>
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link :to="{ name: 'settings' }" class="nav-link"
                                    :class="{ 'active': $route.name === 'settings' }">
                                    <i class="icon-tree5"></i>
                                    <span>Settings</span>
                                </router-link>
                            </li>
                            <li class="nav-item" style="cursor:pointer;"><span style="" @click="logout"
                                    class="nav-link"><i class="icon-exit3"></i> <span>Logout</span></span></li>
                            <!--  <li class="nav-item">
                                <router-link :to="'/logout'" class="nav-link">
                                    <i class="icon-exit2"></i>
                                    <span>Logout</span>
                                </router-link>
                            </li> -->
                        </ul>
                    </div>
                    <!-- /main navigation -->
                </div>
                <!-- /sidebar content -->
            </div>
            <!-- /main sidebar -->
            <!-- Main content -->
            <div class="content-wrapper">
                <router-view></router-view>
            </div>
            <list-sorter v-if="listSorter" @close="listSorter = false" />
            <!-- /main content -->
        </div>
    </div>
</template>
<script>
import modal from "./common/Modal.vue";
import ListSorter from "./modal/ListSorter.vue";
export default {
    components: { modal, ListSorter },
    data() {
        return {
            checking: false,
            authenticated: false,
            responseTime: 0,
            serverUptime: null,
            refreshRequired: false,
            show: false,
            connectionError: false,
            loggedIn: false,
            sidebarVisible: false,

            listSorter: false,
        };
    },
    mounted() { },
    methods: {
        logout() {
            this.$api.area = "public";

            this.$api.getReq("logout").then(() => {
                this.$storage.authenticated = false;
                this.$router.push({ name: "auth" });
            });
        },
        toggleSidebar() {
            this.sidebarVisible = !this.sidebarVisible;
            if (this.sidebarVisible) {
                this.toggleBodyClass("addClass", "sidebar-mobile-main");
            } else {
                this.toggleBodyClass(null, "sidebar-mobile-main");
            }
        },
        toggleBodyClass(addRemoveClass, className) {
            const el = document.body;
            console.log(addRemoveClass, className);
            if (addRemoveClass === "addClass") {
                el.classList.add(className);
            } else {
                el.classList.remove(className);
            }
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/DashboardLayout.vue